function isSupported(type: 'localStorage' | 'sessionStorage') {
  try {
    const storage = window[type];
    var randomValue = '___RANDOM___KEY____NOT_USE____';
    storage.setItem(randomValue, randomValue);
    storage.removeItem(randomValue);
    return true;
  } catch (e) {
    return false;
  }
}

export const LocalStorage: Storage = {
  clear(): void {
    if (!isSupported('localStorage')) return;
    localStorage.clear();
  },
  getItem(key: string): string | null {
    if (!isSupported('localStorage')) return null;
    return localStorage.getItem(key);
  },
  key(index: number): string | null {
    if (!isSupported('localStorage')) return null;
    return localStorage.key(index);
  },
  removeItem(key: string): void {
    if (!isSupported('localStorage')) return;
    localStorage.removeItem(key);
  },
  setItem(key: string, value: string): void {
    if (!isSupported('localStorage')) return;
    localStorage.setItem(key, value);
  },
  get length(): number {
    if (!isSupported('localStorage')) return 0;
    return localStorage.length;
  },
};

export const SessionStorage: Storage = {
  clear(): void {
    if (!isSupported('sessionStorage')) return;
    sessionStorage.clear();
  },
  getItem(key: string): string | null {
    if (!isSupported('sessionStorage')) return null;
    return sessionStorage.getItem(key);
  },
  key(index: number): string | null {
    if (!isSupported('sessionStorage')) return null;
    return sessionStorage.key(index);
  },
  removeItem(key: string): void {
    if (!isSupported('sessionStorage')) return;
    sessionStorage.removeItem(key);
  },
  setItem(key: string, value: string): void {
    if (!isSupported('sessionStorage')) return;
    sessionStorage.setItem(key, value);
  },
  get length(): number {
    if (!isSupported('sessionStorage')) return 0;
    return sessionStorage.length;
  },
};
